import headerImgEn from "assets/images/v110/header-en.webp"
import infoImgEn from "assets/images/v110/info-en.webp"

export const v110ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
